/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const childRoutes = [];

// Permit Venue Details
childRoutes[childRoutes.length] = {
    path: '/permits/233396',
    exact: true,
    componentName: 'PermitVenuePage',
    title: 'Permit Venue Details',
};

// Cooperators
childRoutes[childRoutes.length] = {
    path: '/permits/233396/cooperators',
    componentName: 'PermitVenuePage',
    title: 'Permit Venue Cooperators',
};

// Permit Venue Division Details
childRoutes[childRoutes.length] = {
    path: '/permits/233396/divisions/:divisionId',
    componentName: 'DivisionDetailsPage',
    title: 'Permit Venue Division Details',
};

// Which Permit Do I Need?
childRoutes[childRoutes.length] = {
    path: '/permits/233396/questionnaire',
    componentName: 'QuestionnairePage',
    title: 'Which Permit Do I Need?',
};

// Select Cooperator
childRoutes[childRoutes.length] = {
    path: '/permits/233396/registration/:reservationIds/select-cooperator',
    componentName: 'SelectCooperatorPage',
    title: 'Select Cooperator',
    requireAuth: true,
};

// Permit Venue Detailed Availability
childRoutes[childRoutes.length] = {
    path: '/permits/233396/registration/detailed-availability',
    componentName: 'AvailabilityPage',
    title: 'Permit Venue Detailed Availability',
};

// Permit Registration
childRoutes[childRoutes.length] = {
    path: '/permits/233396/registration/:reservationIds',
    componentName: 'PermitRegistrationPage',
    title: 'Permit Registration',
    requireAuth: true,
};

// Order Confirmation
childRoutes[childRoutes.length] = {
    path: '/permits/233396/confirmation',
    componentName: 'CartlessConfirmationPage',
    title: 'Order Confirmation',
};

// Tertiary Content
childRoutes[childRoutes.length] = {
    path: '/permits/233396/additional-information',
    componentName: 'TertiaryContentPage',
    title: 'Additional Information',
};

export default childRoutes;
